import { useEffect, useState } from "react";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

type Props = {
  onEditHandler: (id?: number) => void;
  onDeleteHandler: (id?: number) => void;
};

const useGlobalSettingColumnDefs = (
  onEditHandler: Props["onEditHandler"],
  onDeleteHandler: Props["onDeleteHandler"]
) => {
  const { t } = useTranslation();
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs([
      {
        field: "unique_id",
        headerName: t("setting.unique_id"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
        sort: "asc",
      },
      {
        field: "name_th",
        headerName: t("setting.name_th"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "name_en",
        headerName: t("setting.name_en"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "description",
        headerName: t("setting.description"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "",
        filter: false,
        sortable: false,
        width: 100,
        cellStyle: {
          display: "flex",
          justifyContent: "center",
        },
        cellRenderer: (params: ICellRendererParams) => {
          if (
            ["000-1", "000-2"].includes(params.data.unique_id) &&
            [-1, -2].includes(params.data.id)
          )
            return (
              <IconButton onClick={() => onEditHandler(params.data?.id)}>
                <EditIcon />
              </IconButton>
            );
          else if (params.data) {
            return (
              <Box>
                <IconButton onClick={() => onEditHandler(params.data?.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => onDeleteHandler(params.data?.id)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          }
        },
      },
    ]);
  }, [onDeleteHandler, onEditHandler, t]);

  return columnDefs;
};

export default useGlobalSettingColumnDefs;
